import { render } from "./ProductTransfers.vue?vue&type=template&id=0fa00d25"
import script from "./ProductTransfers.vue?vue&type=script&lang=js"
export * from "./ProductTransfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductTransfers/ProductTransfers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fa00d25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fa00d25', __exports__)) {
    api.reload('0fa00d25', __exports__)
  }
  
  module.hot.accept("./ProductTransfers.vue?vue&type=template&id=0fa00d25", () => {
    api.rerender('0fa00d25', render)
  })

}


export default __exports__